export default __webpack_public_path__ + "static/media/default.223c23b3.png";